/* Code for testimonials */
document.addEventListener('DOMContentLoaded', function() {
    if (window.innerWidth <= 768) {
      var testimonialsGrid = document.querySelector('.mltestimonials-grid');
      var flkty = new Flickity(testimonialsGrid, {
        // options
        cellAlign: 'left',
        contain: true,
        wrapAround: true
      });
    }
  });
/* Code for testimonials */
/* Code for sticky add to cart button */
/*document.addEventListener('scroll', function() {
  var productForm = document.querySelector('.ProductForm__AddToCart');
  var pinnedButton = document.querySelector('.mlv-ProductForm__AddToCart');
  var mlreview = document.querySelector('#reviews');
  var mlrecomand = document.querySelector('#shopify-section-product-recommendations');
  var mlyotpowidget = document.querySelector('.yotpo-main-widget');
  var mlfooter = document.querySelector('#section-footer');
  var mldivisionsection = document.querySelector('.mldivision');
  
  if (productForm) {
    var productFormTop = productForm.getBoundingClientRect().top;

    if (productFormTop < 0) {
      pinnedButton.classList.add('active');*/
      // $m("body").append(pinnedButton);
     // mlreview.classList.add('addcss');
     // mlrecomand.classList.add('addcss');
     // mlyotpowidget.classList.add('addcss');
    // mlfooter.classList.add('addcss');
    //  mldivisionsection.classList.add('addcss');
   /* } else {
      pinnedButton.classList.remove('active');*/
     // mlreview.classList.remove('addcss');
    //  mlrecomand.classList.remove('addcss');
     // mlyotpowidget.classList.remove('addcss');
    // mlfooter.classList.remove('addcss');
    //  mldivisionsection.classList.remove('addcss');
  /*  }
  }
});*/
/* Code for sticky add to cart button */
/* Code for video and image section */
// document.addEventListener('DOMContentLoaded', function() {
//   if (window.innerWidth <= 767) {
//     const mediaContainer = document.querySelector('.media-container');
//     const flkty = new Flickity(mediaContainer, {
//       cellAlign: 'center',
//       contain: true,
//       prevNextButtons: false,
//       pageDots: true,
//       autoPlay: true
//     });
//   }
// });
/* Code for video and image section */